module.exports = __webpack_public_path__ + "static/media/larel.93abd30f.png";